export default __webpack_public_path__ + "media/b151e11d05fccfc255f8572a61e7258d34e57d5e2fc309a361c357a2eea76230.svg";